import * as React from 'react';

import * as styles from './JournalHighlightsSliderDesktop.css';
import { SwiperCarousel } from '../../../../../../packages/SwiperCarousel';

interface IJournalHighlightsSliderDesktopProps {
  children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>[];
}

export function JournalHighlightsSliderDesktop({ children }: IJournalHighlightsSliderDesktopProps) {
  return (
    <div className={styles['wrapper']}>
      <SwiperCarousel
        spaceBetween={16}
        slidesPerView={5}
        slidesPerGroup={5}
        allowTouchMove={false}
        className="journal-highlights-carousel"
        testId="JournalHighlightsCarousel"
      >
        {children}
      </SwiperCarousel>
    </div>
  );
}
